import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent implements OnInit {

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.config.showHeader = false;
    this.config.width = window.innerWidth > 768 ? '400px' : 'auto';
    this.config.contentStyle = {
      padding: 0,
      'max-width': '80vw',
      'border-radius': '5px'
    };
  }

  ngOnInit(): void {
  }

  close(): any {
    this.ref.close();
  }

  print(): void {
    this.ref.close('print');
  }
}
